import { ExposureControlService } from 'app/services/exposure-control/base-exposure-control.service';
import { GuardFeatures, IFeatureValue } from 'app/services/exposure-control/ec.typings';

/**
 * Exposure control service for cmd api app
 */
export class CmdApiExposureControlService
    extends ExposureControlService
{
    public static readonly className = 'CmdApiExposureControlService';
    public featuresList: IFeatureValue[] = [];
    constructor() {
        super();
        this._ecCache.set(GuardFeatures.ExpressionValidation, true);
    }

    public async getFeatureValue(feature: IFeatureValue, baseUrl?: string): Promise<string | boolean> {
        return undefined;
    }

    public async checkFeatures(baseUrl?: string): Promise<void> {
        return;
    }
}
